/*
 * D5 — as bolinhas de cor no card da vitrine.
 *
 * O que este arquivo faz: troca a foto do card e o destino do card quando a
 * cliente toca numa bolinha, sem recarregar a página.
 *
 * 🔴 O que ele NÃO faz: ele não é necessário. Cada bolinha já é um link de
 * verdade para a variante, escrito no HTML pelo Liquid. Se este script não
 * carregar, o clique navega e a cliente chega na peça naquela cor do mesmo
 * jeito — só com um carregamento de página no meio. É a diferença entre
 * enhancement e dependência, e ela importa numa loja que carrega app demais.
 *
 * Zero biblioteca. Um custom element e um ouvinte de clique.
 */
(function () {
  if (customElements.get('td-card-swatches')) return;

  class TdCardSwatches extends HTMLElement {
    constructor() {
      super();
      /*
       * O handler é criado UMA vez, no construtor, e não a cada
       * connectedCallback. O editor de temas desconecta e reconecta o mesmo
       * elemento a cada ajuste; com o bind dentro do connectedCallback, cada
       * ida e volta acrescentaria mais um ouvinte e o clique passaria a rodar
       * duas, três, quatro vezes.
       */
      this.aoClicar = this.aoClicar.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.aoClicar);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.aoClicar);
    }

    aoClicar(evento) {
      /*
       * 🔴 Ctrl+clique, Cmd+clique, Shift+clique e o botão do meio são "abra
       * isto em outra aba/janela". Se eu chamar preventDefault neles, eu tiro
       * da cliente um gesto que o navegador dá de graça — e ela vai achar que
       * o site está quebrado, não que eu fui esperto.
       */
      if (evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) {
        return;
      }

      const swatch = evento.target.closest('a.td-swatch');
      if (!swatch) return;

      const card = this.closest('.card-wrapper');
      if (!card) return;

      const foto = swatch.getAttribute('data-img');
      const destino = swatch.getAttribute('href');
      if (!destino) return;

      // Sem foto da variante não há nada a trocar na tela: deixo o link fazer
      // o trabalho dele e navegar. Fingir que trocou seria pior.
      if (!foto) return;

      evento.preventDefault();

      const imagem = card.querySelector('.td-card__img');
      if (imagem) {
        /*
         * `srcset` vence `src` sempre que existe. Como eu tenho uma URL só
         * para a variante (e não um jogo de larguras), o caminho honesto é
         * apagar o srcset e deixar o src mandar — em vez de escrever um srcset
         * de mentira com a mesma imagem em todas as larguras, que faria o
         * navegador baixar a maior em qualquer tela.
         */
        imagem.removeAttribute('srcset');
        imagem.removeAttribute('sizes');
        imagem.src = foto;
        const nome = swatch.getAttribute('aria-label');
        if (nome) imagem.alt = nome;
      }

      // Todos os links do card passam a apontar para a variante escolhida: o
      // título, a foto e o botão de compra rápida. Um card que mostra a peça
      // vermelha e leva para a preta é pior do que um card sem bolinha.
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = destino;
      });
      const rapido = card.querySelector('[data-product-url]');
      if (rapido) rapido.setAttribute('data-product-url', destino);
      // Rodada 2: a compra rápida da Todanua lê `data-td-quick`, não `data-product-url`.
      const rapidoTd = card.querySelector('[data-td-quick]');
      if (rapidoTd) rapidoTd.setAttribute('data-td-quick', destino);

      this.querySelectorAll('a.td-swatch').forEach((outro) => {
        outro.removeAttribute('aria-current');
      });
      swatch.setAttribute('aria-current', 'true');
    }
  }

  customElements.define('td-card-swatches', TdCardSwatches);
})();
